import React, { Component, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// Add future flags configuration
const routerConfig = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

import Preloader from './components/Preloader';
const Layout = lazy(() => import('./container/Layout'));
const StationLayout = lazy(() => import('./container/StationLayout'));
const WidgetLayout = lazy(() => import('./container/WidgetLayout'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./components/TermsOfService'));
const About = lazy(() => import('./components/About'));
const Callback = lazy(() => import('./container/Callback'));
const NotFound = lazy(() => import('./container/404'));
const Logout = lazy(() => import('./container/Logout'));
import IEBrowserDetected from './components/IEBrowserDetected';
import { detect } from 'detect-browser';
import { ROUTE_PATHS } from './routes.config';

const browser = detect();

const NonIEBrowserRoute = ({ element: Component, ...props }) => {
  return (browser?.name !== 'ie') ? <Component {...props} /> : <IEBrowserDetected />;
};

export default class AppRoutes extends Component {
  render() {
    return (
      <Router {...routerConfig}>
        <Suspense fallback={<Preloader style={{ marginTop: 300 }} />}>
          <Routes>
            <Route path={ROUTE_PATHS.home} element={<NonIEBrowserRoute element={Layout} />} />
            <Route path={ROUTE_PATHS.station} element={<StationLayout />} />
            <Route path={ROUTE_PATHS.widget} element={<WidgetLayout />} />
            <Route path={ROUTE_PATHS.privacyPolicy} element={<PrivacyPolicy />} />
            <Route path={ROUTE_PATHS.termsOfService} element={<TermsOfService />} />
            <Route path={ROUTE_PATHS.about} element={<About />} />
            <Route path={ROUTE_PATHS.callback} element={<Callback />} />
            <Route path={ROUTE_PATHS.logout} element={<Logout />} />
            <Route path={ROUTE_PATHS.notFound} element={<NotFound />} />
          </Routes>
        </Suspense>
      </Router>
    );
  }
}
